<template>
  <div class="product">
    <div class="container">
      <section class="section">
        <h3 class="title">樂土產品列表</h3>
        <div class="pd-info">
          <table class="table is-striped is-fullwidth is-responsive">
            <thead>
              <tr>
                <th><abbr title="產品名稱">產品名稱</abbr></th>
                <th><abbr title="產品用途">產品用途</abbr></th>
                <th><abbr title="包裝重量">包裝重量</abbr></th>
                <th><abbr title="售價">售價(NTD)</abbr></th>
                <th><abbr title="施作面積">施作面積(㎡)</abbr></th>
                <th><abbr title="費用">費用(元/㎡)</abbr></th>
                <th><abbr title="購買">購買連結</abbr></th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th><abbr title="產品名稱">產品名稱</abbr></th>
                <th><abbr title="產品用途">產品用途</abbr></th>
                <th><abbr title="包裝重量">包裝重量</abbr></th>
                <th><abbr title="售價">售價(NTD)</abbr></th>
                <th><abbr title="施作面積">施作面積(㎡)</abbr></th>
                <th><abbr title="費用">費用(元/㎡)</abbr></th>
                <th><abbr title="購買">購買連結</abbr></th>
              </tr>
            </tfoot>
            <tbody>
              <tr class="is-selected">
                <th colspan="7">水泥砂漿專用防水添加劑</th>
              </tr>
              <tr>
                <th>通用型多效能防水粉</th>
                <td>適用於各類材料的防水添加劑，或無水泥攪拌器(土牛)時地坪使用</td>
                <td>2kg/包</td>
                <td>NT$ 330</td>
                <td>粗胚1.5cm = 7㎡ <br/>粉光0.5cm = 21㎡ </td>
                <td>47<br/>16</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9F%E9%80%9A%E7%94%A8%E5%9E%8B%E9%98%B2%E6%B0%B4%E7%B2%89" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>抹壁型多效能防水粉</th>
                <td>抹壁砂漿專用水泥防水添加劑</td>
                <td>2kg/包</td>
                <td>NT$ 380</td>
                <td>粗胚1.5cm = 7㎡ <br/>粉光0.5cm = 21㎡ </td>
                <td>50<br/>18</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9F%E6%8A%B9%E5%A3%81%E5%9E%8B%E9%98%B2%E6%B0%B4%E7%B2%89" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr class="is-selected">
                <th colspan="7">泥墨泥礦漆礦物塗料</th>
              </tr>
              <tr>
                <th>泥礦漆礦物塗料1 Gal</th>
                <td>MIT礦物塗料健康無毒無甲醛無VOC自潔</td>
                <td>1 Gal/桶</td>
                <td>NT$ 3360</td>
                <td>20㎡</td>
                <td>168</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%B3%A5%E5%A2%A8%E6%B3%A5%E7%A4%A6%E6%BC%86" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>泥礦漆礦物塗料5 Gal</th>
                <td>MIT礦物塗料健康無毒無甲醛無VOC自潔</td>
                <td>5 Gal/桶</td>
                <td>NT$ 14700</td>
                <td>95㎡</td>
                <td>155</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%B3%A5%E5%A2%A8%E6%B3%A5%E7%A4%A6%E6%BC%86" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>泥礦漆專用透氣底漆5 Gal</th>
                <td>健康無毒透氣</td>
                <td>5 Gal/桶</td>
                <td>NT$ 3360</td>
                <td>95㎡</td>
                <td>36</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%B3%A5%E7%A4%A6%E6%BC%86%E5%B0%88%E7%94%A8%E9%80%8F%E6%B0%A3%E5%BA%95%E6%BC%86" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>泥礦漆專用透氣底漆1 Gal</th>
                <td>健康無毒透氣</td>
                <td>1 Gal/桶</td>
                <td>NT$ 840</td>
                <td>19㎡</td>
                <td>45</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%B3%A5%E7%A4%A6%E6%BC%86%E5%B0%88%E7%94%A8%E9%80%8F%E6%B0%A3%E5%BA%95%E6%BC%86" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr class="is-selected">
                <th colspan="7">樂土灰泥及週邊</th>
              </tr>
              <tr>
                <th>樂土灰泥 絲綢版<span class="color-note">(樂土白 清水灰 樂土灰 水泥灰)</span></th>
                <td>超薄表面修飾砂漿</td>
                <td>5kg/包</td>
                <td>NT$ 1250</td>
                <td>5㎡ </td>
                <td>250</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9F%E7%81%B0%E6%B3%A55kg" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                  <th>樂土灰泥 絨布版<span class="color-note">(珍珠白 菊島灰 鮮奶茶 珊瑚粉 海洋灰)</span></th>
                <td>超薄表面修飾砂漿</td>
                <td>5kg/包</td>
                <td>NT$ 1400</td>
                <td>5㎡ </td>
                <td>280</td>
                <td><a href="https://shop.ezarch.com.tw/%E7%B5%A8%E5%B8%83%E5%9E%8B%E6%96%B0%E7%89%88%E6%A8%82%E5%9C%9F%E7%81%B0%E6%B3%A5" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>灰泥作業改良劑</th>
                <td>增加灰泥工作緩凝滑順性能</td>
                <td>1.8kg/桶</td>
                <td>NT$ 1050</td>
                <td>抹鏝對應3包5kg灰泥，噴滾塗對應1包5kg灰泥</td>
                <td>n/a</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9F%E7%81%B0%E6%B3%A5%E4%BD%9C%E6%A5%AD%E6%94%B9%E8%89%AF%E5%8A%91" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>TOP面塗</th>
                <td>輕度霧面潑水保護</td>
                <td>1.8L/桶</td>
                <td>NT$ 650</td>
                <td>12㎡</td>
                <td>54.17</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9FTOP%E9%9D%A2%E5%A1%97%E6%B0%B4%E6%80%A7%E9%98%B2%E8%AD%B7" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>F93無機防護面塗</th>
                <td>成膜霧面強化保護</td>
                <td>1L/桶</td>
                <td>NT$ 1680</td>
                <td>12㎡</td>
                <td>140</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%B3%A5%E5%A2%A8F93%E7%84%A1%E6%A9%9F%E9%98%B2%E8%AD%B7%E9%9D%A2%E5%A1%97" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr class="is-selected">
                <th colspan="7">防水介面塗層</th>
              </tr>
              <tr>
                <th>樂塗防水透氣漆</th>
                <td>戶外屋頂 外牆壁面防水塗層</td>
                <td>18kg/桶<br/>4kg/桶</td>
                <td>NT$ 2100<br/>NT$ 500</td>
                <td>45㎡<br/>9㎡</td>
                <td>52.5<br/>5.5</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E5%A1%97%E9%98%B2%E6%B0%B4%E9%80%8F%E6%B0%A3%E6%BC%86" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>樂天BB漆</th>
                <td>戶外屋頂隔熱防水塗層</td>
                <td>20kg/桶<br/>4kg/桶</td>
                <td>NT$ 2450<br/>NT$ 650</td>
                <td>50㎡<br/>10㎡</td>
                <td>49<br/>65</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E5%A4%A9BB%E9%98%B2%E6%B0%B4%E9%9A%94%E7%86%B1%E6%BC%86" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>單組份彈性水泥</th>
                <td>浴室屋頂防水中塗層</td>
                <td>5Gal/桶<br/>1 Gal/桶</td>
                <td>NT$ 1550<br/>NT$ 480</td>
                <td>18㎡<br/>4㎡</td>
                <td>86<br/>120</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E5%9C%9F%E5%96%AE%E7%B5%84%E4%BB%BD%E5%BD%88%E6%80%A7%E6%B0%B4%E6%B3%A5" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>水性介面接著底漆</th>
                <td>粉化或水泥地面打底塗層</td>
                <td>5Gal/桶<br/>1 Gal/桶</td>
                <td>NT$ 2350<br/>NT$ 580</td>
                <td>150㎡<br/>35㎡</td>
                <td>15.6<br/>16.57</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%B0%B4%E6%80%A7%E7%95%8C%E9%9D%A2%E6%8E%A5%E8%91%97%E5%BA%95%E6%BC%86" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>矽酸質塗佈型防水材WP-800</th>
                <td>負水壓打底塗層</td>
                <td>25kg/包<br/>5kg/包</td>
                <td>NT$3800<br/>NT$ 800</td>
                <td>16.6㎡<br/>3.32㎡</td>
                <td>229<br/>240</td>
                <td><a href="https://shop.ezarch.com.tw/%E7%9F%BD%E9%85%B8%E8%B3%AA%E5%A1%97%E4%BD%88%E5%9E%8B%E9%98%B2%E6%B0%B4%E6%9D%90WP-800" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr class="is-selected">
                <th colspan="7">壁癌處理專用超薄防水沙漿</th>
              </tr>
              <tr>
                <th>DIY壁癌專用工具組2kg</th>
                <td>內含本色樂繕1kg及白色樂繕1kg及工具組說明書</td>
                <td>2kg/桶</td>
                <td>NT$ 310</td>
                <td>1㎡</td>
                <td>310</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E7%B9%95%E8%B6%85%E8%96%84%E6%8A%B9%E9%9D%A2%E7%A0%82%E6%BC%BF2kg%E5%8F%8A%E5%B7%A5%E5%85%B7%E7%B5%84%E5%90%88" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>白色樂繕</th>
                <td>防水透氣批土</td>
                <td>5kg/包</td>
                <td>NT$ 400</td>
                <td>10-15㎡</td>
                <td>27-40</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E7%B9%95%E7%99%BD%E8%89%B25kg" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
              <tr>
                <th>本色樂繕</th>
                <td>牆面地面整平打底</td>
                <td>5kg/包</td>
                <td>NT$ 360</td>
                <td>5㎡</td>
                <td>72</td>
                <td><a href="https://shop.ezarch.com.tw/%E6%A8%82%E7%B9%95%E6%9C%AC%E8%89%B25kg" target="_blank" class="button is-primary is-outlined call-in-action">購買</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '../mq'
h3
  color: #666
  font-size: 2rem

.pd-info
  overflow-x: auto
  table
    +mobile
      table, thead, tbody, th, td, tr
        display: block;

      thead, tfoot
        position: absolute
        top: -9999px
        left: -9999px
      tr
          border: 1px solid #ccc

      td
        /* Behave  like a "row" */
        border: none;
        border-bottom: 1px solid #eee
        position: relative
        padding-left: 50%


      td:before
        /* Now like a table header */
        position: absolute;
        /* Top/left values mimic padding */
        top: 6px
        left: 6px
        width: 45%
        padding-right: 10px
        white-space: nowrap


      /*Label the data*/
      td:nth-of-type(1):before
         content: "產品用途"
      td:nth-of-type(2):before
         content: "包裝重量"
      td:nth-of-type(3):before
         content: "售價(NTD)"
      td:nth-of-type(4):before
        content: "施作面積(㎡)"
      td:nth-of-type(5):before
        content: "費用(元/㎡)"
      td:nth-of-type(6):before
        content: "線上購買"
      td:nth-of-type(7):before
        content: "Date of Birth"
      td:nth-of-type(8):before
        content: "Dream Vacation City"
      td:nth-of-type(9):before
        content: "GPA"
      td:nth-of-type(10):before
        content: "Arbitrary Data"


    .color-note
      font-size: 0.5rem
      color: #999
    tr.is-selected
      th
        text-align: center
        background-color: #699

  .call-in-action
    color: #fff
    border: 1px solid #fff
    background: #396ab3
    font-weight: bold

  .color-note
    font-size: .8rem !important

</style>



// WEBPACK FOOTER //
// src/components/Product.vue